import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './Footer.css';
import appLogo from '../../assets/appLogoHeader.png';
import apple from '../../assets/apple.png';

function Footer() {
  const { t } = useLanguage();
  
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer" id="footer">
      <div className="footer-border"></div>
      
      <div className="container">
        <div className="footer-content">
          <div className="footer-main">
            <div className="footer-logo">
              <img src={appLogo} alt="Quizzer Logo" />
              <p className="footer-slogan footer-slogan-white">{t('slogan')}</p>
            </div>
            
            <div className="footer-links">
              <div className="footer-links-column">
                <h3>{t('accueil')}</h3>
                <ul>
                  <li><a href="#categories">{t('themes')}</a></li>
                  <li><a href="#faq">FAQ</a></li>
                </ul>
              </div>
              
              <div className="footer-links-column">
                <h3>{t('download')}</h3>
                <div className="download-buttons">
                  <button className="btn btn-download">
                    <img src={apple} alt="Apple" className="btn-icon" />
                    <span>{t('appstore')}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          <div className="footer-bottom">
            <p className="copyright">© {currentYear} Quizzer. {t('droitsReserves')}</p>
            <div className="footer-legal">
              <a href="/terms" className="footer-link">{t('termsOfService')}</a>
              <span className="footer-separator">|</span>
              <a href="/privacy" className="footer-link">{t('privacyPolicy')}</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 